import script from "./GuidedProgramTargets.vue?vue&type=script&setup=true&lang=js"
export * from "./GuidedProgramTargets.vue?vue&type=script&setup=true&lang=js"

import "./GuidedProgramTargets.vue?vue&type=style&index=0&id=1bc6d35c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc6d35c"]])

export default __exports__